import CodeSectionNew from './code-section-new';

export default CodeSectionNew;
